import Img from "./img";

const PoweredByStripe = () => {
  return (
    <div className="stripe-svg">
      <Img
        className="dark-icon"
        src="/images/svg/stripe/white.svg"
        alt="Powered by Stripe"
      />
      <Img
        className="light-icon"
        src="/images/svg/stripe/black.svg"
        alt="Powered by Stripe"
      />
    </div>
  );
};

export default PoweredByStripe;
